import './App.css';

import Navbar from './components/Navbar';
import FloatingSidebar from './components/FloatingSidebar';
import Footer from './components/Footer';

import Header from './components/Header';
import Memberships from './components/Memberships';
import Financing from "./components/Financing"
import Counseling from './components/Counseling';
import FAQ from './components/FAQ';
import Trailer from './components/Trailer';
import Information from './components/Information';
import WhatWillYouLearn from './components/WhatWillYouLearn';


function App() {
  return (
    <main className="App">
      <Navbar />
      <FloatingSidebar />
      <Header />
      <Trailer />
      <Information />
      <WhatWillYouLearn />
      <Memberships />
      <Financing />
      <Counseling />
      <FAQ />
      <Footer />
    </main>
  );
}

export default App;
